export const InsightsPreferences = {
  PROJECT_ID: 'externalAnalytics.projectId',
};

// Tall enough so the WarehouseBrowserDetails with max height (i.e. 5 rows) is not taller.
export const BLOCK_EDITOR_TOP_ROW_HEIGHT = 205; // px
export const DEFAULT_BLOCK_HEIGHT = 400; // px
// Use vh to make the blocks change heights depending on the user's resolution. 77vh is an approximation of
// full screen - the height of the dashboard header and benchling editor's top and bottom bars. We can't
// get an exact number because the dashboard header changes, but this works on most standard screen sizes.
export const EXPANDED_BLOCK_HEIGHT = '77vh';
export const MINIMUM_BLOCK_WIDTH = 500; // px
// Spacing between the edges of panes and their contents.
export const PANE_MARGIN = 12; // px
export const SQL_TEMPLATE_FORM_HEIGHT = 550; // px
export const VISUALIZATION_EDITOR_HEIGHT = DEFAULT_BLOCK_HEIGHT + 50; // px

export const INSIGHTS_HELP_URL = 'https://help.benchling.com/hc/sections/8506377929869';

// Keep in sync with benchling/insights/constants.py:MAX_DASHBOARD_BLOCKS
export const MAX_DASHBOARD_BLOCKS = 100;
export const MAX_DASHBOARD_BLOCKS_MESSAGE = `Dashboards support up to ${MAX_DASHBOARD_BLOCKS} blocks. Please remove blocks or create a new dashboard.`;

export const QUERY_LOADING_MESSAGE = 'Running query...';
